import { StaticImageData } from 'next/image';
import React from 'react';
import {
  Container,
  ContainerFluid,
  Htag,
  HtagVariant,
  Paragraph,
  Scrolling,
} from '../../components';
import styles from './hera-page-illustrations.module.css';

import scroll1 from '../../public/scroll/1.png';
import scroll2 from '../../public/scroll/2.png';
import scroll3 from '../../public/scroll/3.png';
import scroll4 from '../../public/scroll/4.png';
import scroll5 from '../../public/scroll/5.png';
import scroll6 from '../../public/scroll/6.png';
import scroll7 from '../../public/scroll/7.png';
import scroll8 from '../../public/scroll/8.png';

const scrolling: StaticImageData[] = [
  scroll1,
  scroll2,
  scroll3,
  scroll4,
  scroll5,
  scroll6,
  scroll7,
  scroll8,
];

export default function HeraPageIllustrations() {
  return (
    <section className={styles.illustrations}>
      <Container>
        <Htag
          tag="h3"
          className={styles.illustrations_title}
          variant={HtagVariant.h3}
        >
          80+ CUSTOM ILLUSTRATIONS
        </Htag>
        <Paragraph className={styles.illustrations_text}>
          The tips for pregnancy, postnatal and baby loss periods were described
          and painted in 82 illustrations.
        </Paragraph>
      </Container>
      <ContainerFluid>
        <Scrolling images={scrolling} />
      </ContainerFluid>
    </section>
  );
}
